import { Component, Input } from '@angular/core';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { SearchRangeModel } from '../../../../Monitor/Core/models/search-range.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-date-query-input-dialog',
    templateUrl: './date-query-input-dialog.component.html',
    styleUrls: ['./date-query-input-dialog.component.scss'],
    standalone: false
})

export class DateQueryInputDialogComponent extends AbstractDialogComponent {

    @Input() id: string;
    @Input() header: string;

    @Input() options: DropdownOptionModel[];
    @Input() selectedOption: DropdownOptionModel;

    @Input() dateRange: SearchRangeModel;
    @Input() useToDate: boolean = false;
    @Input() setEndOfDayTime: boolean = true;

    @Input() dateTypeOptions: DropdownOptionModel[];
    @Input() hideDateTypeSelection: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'DateQueryInput');
    }

    /**
     * Action when the user clicks the "apply" button
     */
    apply(): void {
        this.closeDialog(this.selectedOption);
    }

    /**
     * Action when the user clicks the "cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(null);
    }
}
